import { onUnmounted } from 'vue'
import { consumer } from 'stores/cable.js'
import { useCalendarStore } from 'stores/calendar.js'

export function useCalendarChannel() {
  const store = useCalendarStore()
  let subscription = null

  function connect() {
    if (subscription) return // already connected

    subscription = consumer.subscriptions.create('CalendarChannel', {
      connected() {
        store.setConnectionStatus('connected')
      },

      disconnected() {
        store.setConnectionStatus('disconnected')
      },

      rejected() {
        store.setConnectionStatus('rejected')
      },

      received(data) {
        switch (data.type) {
          case 'booking_created':
            store.addBooking(data.booking)
            break
          case 'booking_updated':
            store.updateBooking(data.booking)
            break
          case 'booking_canceled':
            store.removeBooking(data.booking.id)
            break
        }
      },
    })
  }

  function disconnect() {
    if (subscription) {
      subscription.unsubscribe()
      subscription = null
    }
    store.setConnectionStatus('disconnected')
  }

  // Auto-disconnect when the component that called this composable unmounts.
  onUnmounted(disconnect)

  return { connect, disconnect }
}
